import * as actiontypes from '../../constants/actionType';

export function setSessionHubSignalR(hub) {
  return {type: actiontypes.SET_SESSION_HUB, hub};
}

export function setAuthoringHubSignalR(hub) {
  return {type: actiontypes.SET_AUTHORING_HUB, hub};
}

export function setStateHubSignalR(hub) {
  return {type: actiontypes.SET_STATE_HUB, hub};
}

export function setInstrumentHubSignalR(hub) {
  return {type: actiontypes.SET_INSTRUMENT_HUB, hub};
}

export function setTrayHubSignalR(hub) {
  return {type: actiontypes.SET_TRAY_HUB, hub};
}

export function setUserManagementHubSignalR(hub) {
  return {type: actiontypes.SET_USER_MANAGEMENT_HUB, hub};
}

export function setLabwareDefinitionHubSignalR(hub) {
  return {type: actiontypes.SET_LABWARE_DEFINITION_HUB, hub};
}

export function setProtocolHubSignalR(hub) {
  return {type: actiontypes.SET_PROTOCOL_HUB, hub};
}

export function setProtocolManagementHubSignalR(hub) {
  return {type: actiontypes.SET_PROTOCOL_MANAGEMENT_HUB, hub};
}

export function setSoftwareUpdaterHubSignalR(hub) {
  return {type: actiontypes.SET_SOFTWARE_UPDATER_HUB, hub};
}

export function setBackupAndRestoreHubSignalR(hub) {
  return {type: actiontypes.SET_BACKUP_AND_RESTORE_HUB, hub};
}

export function setHubSignalR(hubName, hub) {
  return {type: actiontypes.SET_HUB, hubName, hub};
}

export const setLatestSignalREventReceived = (event) => ({
  type: actiontypes.SET_LATEST_SIGNAL_R_EVENT_RECEIVED,
  event,
});
